import dayjs from "dayjs";
import { __ } from "./i18n";

const EIGHTEEN_YEARS = 18;
const ONE_HUNDRED_YEARS = 100;

export function validDate(
	value: string,
	required = false,
	checkAgeLimit = false,
	msg = "A dátum megadása kötelező!",
): string {
	if (!value && required) {
		return msg;
	}

	if (value.length < 9) {
		return "Adja meg a teljes dátumot!";
	}

	if (value.length === 9) {
		return "Rossz dátum formátum! (Használja például így: 2000-10-02)";
	}

	if (value.includes("-00") && !value.matchAll(/\d{4}-\d{2}-\d{2}/)) {
		return "Érvénytelen dátum!";
	}

	if (dayjs(value, "YYYY-MM-DD", true).format("YYYY-MM-DD") !== value) {
		return "Érvénytelen dátum!";
	}

	if (checkAgeLimit === true) {
		const age = Math.abs(dayjs(value).diff(dayjs(), "year"));

		// 18 éven felülieknek
		if (age < EIGHTEEN_YEARS) {
			return __("Az ügyfélnek nagykorúnak kell lennie.");
		}

		// 100 éven aluliaknak
		if (age >= ONE_HUNDRED_YEARS) {
			return __("Az ügyfélnek 100 éven alulinak kell lennie.");
		}
	}

	return null;
}
